<div class="animate__animated animate__fadeInRight">
<br>
    <div class="col">
      <mat-card class="mat_card_general p-5">
        <h1 class>Modulo de Sucursales</h1>
      </mat-card>
    </div>
    <br>

    <mat-card class="mat-elevation-z0 mat_card_general_content">
      <app-agregar-sucursales
        (onDebounce)="actualizarTabla($event)"
      ></app-agregar-sucursales>
      <br />
      <app-lista-sucursales
      ></app-lista-sucursales>
    </mat-card>
    <hr />
  </div>
